import { createFileRoute } from '@tanstack/react-router';

import { useSEO, useBreadcrumbSchema, PageSEO } from '../lib/seo';
import { LegalDocPage } from '../components/legal/LegalDocPage';
// Body extracted verbatim from sites/www/public/cookies/index.html (see privacy.tsx note).
import cookiesBody from '../content/legal/cookies.body.html?raw';

export const Route = createFileRoute('/cookies')({
  component: CookiesPage,
});

function CookiesPage() {
  useSEO(PageSEO.cookies);
  useBreadcrumbSchema([
    { name: 'Home', url: '/' },
    { name: 'Trust', url: '/trust' },
    { name: 'Cookies Notice', url: '/cookies' },
  ]);

  return (
    <LegalDocPage
      title="Cookies notice"
      breadcrumbLabel="Cookies Notice"
      metaLine="v1.0 · 27 April 2026"
      subtitle="The cookies and similar technologies we use, why we use them, and how to manage them."
    >
      <div dangerouslySetInnerHTML={{ __html: cookiesBody }} />
    </LegalDocPage>
  );
}
